import PropTypes from 'prop-types';
import React from 'react';
import api from '../../../Api';
import makeConnectTo from '../../util/makeConnectTo';
import * as Util from '../../../util';

const CollectionTitlesContext = React.createContext();

const name = 'collectionTitlesDataStore';

export const connectToCollectionTitles = makeConnectTo(
	CollectionTitlesContext,
	name,
);

export default class CollectionTitlesDataStore extends React.Component {
	static propTypes = {
		children: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
	};

	state = {
		collectionTitles: [],
		areCollectionTitlesLoading: true,
	};

	render() {
		const collectionTitlesDataStore = this.getStore();
		return (
			<CollectionTitlesContext.Provider value={collectionTitlesDataStore}>
				{typeof this.props.children === 'function'
					? this.props.children(collectionTitlesDataStore)
					: this.props.children}
			</CollectionTitlesContext.Provider>
		);
	}

	componentDidMount() {
		this.fetchCollectionTitles();
	}

	componentWillUnmount() {
		if (this.collectionTitlesFetch && this.collectionTitlesFetch.cancel) {
			this.collectionTitlesFetch.cancel();
		}
	}

	getStore = (state = this.state) => ({
		state,
		refresh: () => this.refreshCollectionTitles(),
	});

	refreshCollectionTitles = () => {
		this.setState({
			areCollectionTitlesLoading: true,
		});
		this.fetchCollectionTitles();
		return this.collectionTitlesFetch.promise;
	};

	fetchCollectionTitles = () => {
		const { catalogId } = this.props;
		const request = api.cancelableGet(
			`/api/v1/catalogs/${catalogId}/titles`,
		);
		request.promise.then(this.cacheApiResponse);
		this.collectionTitlesFetch = request;
	};

	cacheApiResponse = apiResponse => {
		const collectionTitles = apiResponse && Util.createTitleObject(apiResponse);
		this.setState({ collectionTitles, areCollectionTitlesLoading: false });
	};
}
